
import { browserHistory } from 'react-router'
import { modal } from '../utilities/modal'
import { levelRenderer } from '../../core/graphic_engine/controllers/LevelRenderer'
import { buildingRenderer } from '../../core/graphic_engine/controllers/building'

var ActiveSensorsManager = Class.create({
    activeSensors: [],
    activeTimeouts: [],
  	initialize: function() {
    },
    setData: function(mesh, context, sensor_data) {
        // if(this.isDuplicate(sensor_data) || sensor_data === undefined) {
        //     return;
        // }

        this.activeSensors.push({
            model: mesh,
            isActive: false,
            timeout: null,
            renderer: context.context.state.renderer,
            scene: context.scene,
            camera: context.camera,
            sensor_uuid: sensor_data.sensor_uuid
        });
    },
    setDataWithScene: function(mesh, context, scene, camera, sensor_data) {
        // if(this.isDuplicate(mesh) || mesh === undefined) {
        //     return;
        // }

        this.activeSensors.push({
            model: mesh,
            isActive: false,
            timeout: null,
            renderer: context.context.state.renderer,
            scene: scene,
            camera: camera,
            sensor_uuid: sensor_data.sensor_uuid
        });
    },
    isDuplicate: function(sensor_data) {
        var duplicateFound = false;
        this.activeSensors.forEach(function(sensor) {
            if(sensor.sensor_uuid == sensor_data.sensor_uuid) {
                if(Object.is(sensor.sensor_uuid, sensor_data.sensor_uuid)) {
                    duplicateFound = true;
                }
            }
        });

        return duplicateFound;
    },
    clearWindowTimeouts: function() {
        this.activeTimeouts.forEach(timeout => {
            window.clearTimeout(timeout);
        });
        this.activeTimeouts = [];
    },
    displayActiveSensorColorChange: function() {
        var self = this;
        this.activeSensors.forEach(sensor => {
            if(!sensor.isActive) {
                sensor.isActive = true;

                const startColor = sensor.model.material.materials[0].color.getHex();
				const endColor   = 0xF1C232;
				var didChange    = false;
                var timeout = window.setInterval(function(){
					const colorToUse = didChange ? startColor : endColor;
                    didChange = didChange ? false : true;
                    sensor.model.material.materials.forEach( material => {
                        material.color.setHex(colorToUse);
                    });
                    sensor.renderer.render( sensor.scene, sensor.camera );
                }, 1000);

                self.activeTimeouts.push(timeout);
            }
        });
    }
});

export let activeSensorsManager = new ActiveSensorsManager();


// WEBPACK FOOTER //
// app/core/controllers/ActiveSensorsManager.js